import { render, staticRenderFns } from "./EditCommunity.vue?vue&type=template&id=c7323880&scoped=true"
import script from "./EditCommunity.vue?vue&type=script&lang=js"
export * from "./EditCommunity.vue?vue&type=script&lang=js"
import style0 from "./EditCommunity.vue?vue&type=style&index=0&id=c7323880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7323880",
  null
  
)

export default component.exports